import EmojiText from './EmojiText';

export default EmojiText;
